import { ApolloError } from '@apollo/client';

import { GeneratedMoneyInput } from '../../../types/generated';

type Money = { amount: string; currencyCode: string };

type BidRules = {
  floor?: Money | null;
  promptUserAboutWinningBid?: boolean | null;
  reserve?: Money | null;
};

type BidTooLowExtensions = {
  code?: string;
  details?: {
    floor_price?: string;
    floor_price_currency_code?: string;
  };
};

const promptedFloor = ({ floor, promptUserAboutWinningBid }: BidRules) => {
  return promptUserAboutWinningBid && floor ? Number(floor.amount) : 0;
};

export const minimumBid = (rules: BidRules): number => {
  return Math.max(Number(rules.reserve?.amount ?? 0), promptedFloor(rules));
};

export const acceptsBid = (bid: number, rules: BidRules): boolean => {
  const floor = promptedFloor(rules);

  return (
    Number.isFinite(bid) &&
    bid >= Number(rules.reserve?.amount ?? 0) &&
    (floor === 0 || bid > floor)
  );
};

export const bidFloorFromError = (
  error: unknown,
): GeneratedMoneyInput | null => {
  if (!(error instanceof ApolloError)) return null;

  const extensions = error.graphQLErrors[0]?.extensions as
    | BidTooLowExtensions
    | undefined;
  if (extensions?.code !== 'BID_TOO_LOW') return null;
  if (!extensions.details?.floor_price) return null;

  return {
    amount: extensions.details.floor_price,
    currencyCode: extensions.details.floor_price_currency_code ?? '',
  };
};
